import { defineComponent, h, ref } from 'vue';
import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/components/icon/Icon';
import { t } from '@/ui/i18n/i18n';
import { hasConvertedForm } from '@/ui/auth/auth';
import { tooltip } from '@/ui/components/Tooltip';
import { HubspotSendFormModal } from '@/ui/components/modals/HubspotSendFormModal';
import { featureExplanationIcon } from '@/ui/components/icon/icons';

export const Buttons = defineComponent({
  name: 'Buttons',
  setup() {
    const isOpenSendFormModal = ref(false);
    const onSendFormModalClose = () => {
      isOpenSendFormModal.value = false;
    };
    const onSendFormButtonClick = () => {
      isOpenSendFormModal.value = true;
    };

    return function render() {
      return h('div', { class: 'checklist-templates__buttons' }, [
        h(HubspotSendFormModal, {
          props: { active: isOpenSendFormModal.value },
          on: { close: onSendFormModalClose },
        }),
        h(Button, {
          attrs: {
            tag: 'router-link',
            to: { name: 'checklistCreate' },
          },
        }, [
          h(Icon, { props: { icon: 'file-edit' } }),
          h('div', { class: 'checklist-templates__btn-text' }, [
            t('checklist-templates.create-template-from-scratch'),
          ]),
        ]),

        hasConvertedForm.value
          ? null
          : h('div', { class: 'checklist-templates__send-form-container' }, [
            h(Button, {
              props: { btnClass: 'checklist-templates__send-form', outlined: true },
              on: { click: onSendFormButtonClick },
            }, [
              h(Icon, { props: { icon: 'upload' } }),
              h('div', { class: 'checklist-templates__btn-text' }, [
                t('convert-form.send-us-your-form'),
              ]),
            ]),
            tooltip({
              label: t('feature-explanation.convert-form'),
              multilined: true,
              position: 'is-bottom',
              classes: 'ml-2',
            }, [featureExplanationIcon()], 'label'),
          ]),
      ]);
    };
  },
});
